import * as yup from 'yup';

import { allgemeinSchema } from '@/features/Sparten/shared/schema/kfz/notPkw/allgemeinSchema/allgemeinSchema';
import { KASKOTYP } from '@/features/Sparten/shared/types';
import {
  hasFahrerschutzversicherung,
  hasRabattschutzKfzHaftpflicht,
  hasRabattschutzKfzVollkasko,
  hasSfKlasseReactive,
} from '@/features/Sparten/shared/renderConditions/kfz/sharedRenderConditions';
import { versicherungsnehmerSchema } from '@/features/Sparten/camp/schema/versicherungsnehmerSchema/versicherungsnehmerSchema';
import { fahrzeugSchema } from '@/features/Sparten/camp/schema/fahrzeugSchema/fahrzeugSchema';
import { baseInputSchema } from '@/features/Sparten/shared/schema/kfz/baseInputSchema';
import { erstfahrzeugSchema } from '@/features/Sparten/shared/schema/kfz/erstfahrzeugSchema/erstfahrzeugSchema';
import { fahrerkreisSchema as kfzFahrerkreisSchema } from '@/features/Sparten/shared/schema/kfz/fahrerkreisSchema/fahrerkreisSchema';

export const campSchema = baseInputSchema.concat(
  yup.object({
    allgemein: allgemeinSchema,
    erstfahrzeug: erstfahrzeugSchema,
    fahrerkreis: kfzFahrerkreisSchema,
    fahrzeug: fahrzeugSchema,
    sfKlasseKH: yup
      .string()
      .default('')
      .when({
        is: () => hasSfKlasseReactive.value,
        then: yup.string().required(),
      }),
    sfKlasseVK: yup
      .string()
      .default('')
      .when('kaskoTyp', {
        is: (val: string) =>
          val === KASKOTYP.VOLLKASKO && hasSfKlasseReactive.value,
        then: yup.string().required(),
      }),
    versicherungsnehmer: versicherungsnehmerSchema,
    fahrerschutzversicherung: yup
      .boolean()
      .default(false)
      .when({
        is: () => hasFahrerschutzversicherung.value,
        then: yup.boolean().required(),
      }),
    rabattschutzKfzHaftpflicht: yup
      .boolean()
      .default(false)
      .when({
        is: () => hasRabattschutzKfzHaftpflicht.value,
        then: yup.boolean().required(),
      }),
    rabattschutzVollkasko: yup
      .boolean()
      .default(false)
      .when({
        is: () => hasRabattschutzKfzVollkasko.value,
        then: yup.boolean().required(),
      }),
  }),
);
